import { render, staticRenderFns } from "./SvgHtml.vue?vue&type=template&id=2461344c"
import script from "./SvgHtml.vue?vue&type=script&lang=js"
export * from "./SvgHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports